import { NavLink, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/gallery", label: "Gallery" },
  { to: "/flutes", label: "Love Flutes" },
  { to: "/drums", label: "Drums" },
  { to: "/didgeridoos", label: "Didgeridoos" },
  { to: "/story", label: "The Story" },
  { to: "/stories", label: "Stories" },
  { to: "/connect", label: "Connect" },
  { to: "/commissions", label: "Commissions" },
  { to: "/contact", label: "Contact" },
];

export default function Nav({ artisanName = "Sacred Instruments" }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const linkCls = ({ isActive }) =>
    `text-sm tracking-wide transition-colors ${isActive ? "text-[var(--si-terracotta)]" : "hover:text-[var(--si-terracotta)]"}`;

  return (
    <nav className="nav-glass fixed top-0 inset-x-0 z-50">
      <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between">
        <Link to="/" className="font-display text-xl tracking-tight" data-testid="nav-brand">
          {artisanName}
        </Link>
        <div className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={linkCls} data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}>
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className="flex items-center gap-4">
          <Link to="/admin/login" className="label-eyebrow hover:text-[var(--si-terracotta)] transition-colors hidden md:inline-block" data-testid="nav-admin-link">
            Admin
          </Link>
          <button className="lg:hidden text-[var(--si-text)]" onClick={() => setOpen((o) => !o)} aria-label="Menu" data-testid="nav-mobile-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[var(--si-border)] px-6 py-4 space-y-3 bg-[var(--si-bg)]" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `block py-1 text-base ${isActive ? "text-[var(--si-terracotta)]" : ""}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/admin/login" className="block py-1 text-base">Admin</Link>
        </div>
      )}
    </nav>
  );
}
